import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { storyblokEditable } from "@storyblok/react"

import { BigBlogTeasers } from "gatsby-theme-gba"
import BigBlogTeaser from "./big-blog-teaser"

const BigBlogTeasersEditable = ({ blok }) => {
  const defaultLang = process.env.GATSBY_DEFAULT_LANG
    ? process.env.GATSBY_DEFAULT_LANG
    : "de"
  const blogStories = useStaticQuery(graphql`
    query BigBlogQuery {
      allStoryblokEntry(
        sort: { sort_by_date: DESC }
        filter: {
          default_full_slug: { regex: "/^(blog|news)/" }
          is_startpage: { eq: false }
        }
      ) {
        nodes {
          uuid
          tag_list
          lang
          name
          full_slug
          content
          published_at
          sort_by_date
          first_published_at(formatString: "YYYY-MM-DD")
          translated_slugs {
            lang
            path
          }
        }
      }
      fallbackStories: allStoryblokEntry(
        sort: { sort_by_date: DESC }
        filter: {
          full_slug: { regex: "/^(blog|news)/" }
          is_startpage: { eq: false }
        }
      ) {
        nodes {
          uuid
          tag_list
          lang
          name
          full_slug
          content
          published_at
          sort_by_date
          first_published_at(formatString: "YYYY-MM-DD")
          translated_slugs {
            lang
            path
          }
        }
      }
      listingPages: allStoryblokEntry(
        filter: { field_component: { eq: "blogListing" } }
      ) {
        nodes {
          uuid
          lang
          name
          full_slug
          content
          translated_slugs {
            lang
            path
          }
        }
      }
    }
  `)

  const todayDate = new Date()
  const dd = String(todayDate.getDate()).padStart(2, "0")
  const mm = String(todayDate.getMonth() + 1).padStart(2, "0")
  const yyyy = todayDate.getFullYear()

  const today = `${yyyy}-${mm}-${dd}`

  const filterLang =
    blok.currentLanguage === defaultLang ? "default" : blok.currentLanguage

  let defaultStories = blogStories.allStoryblokEntry.nodes
  const allStories = defaultStories.length
    ? blogStories.allStoryblokEntry.nodes
    : blogStories.fallbackStories.nodes

  let listingPages = blogStories.listingPages.nodes.filter(
    (node) => node.uuid === blok.bigBlogTeaserListing
  )

  const currentLanguageListingPage = listingPages.filter(
    (node) => node.lang === filterLang
  )[0]

  let customFallbackLang = "en"

  listingPages = listingPages.sort((firstEl, secondEl) => {
    if (firstEl.lang === secondEl.lang) {
      return 0
    }
    if (firstEl.lang === customFallbackLang) {
      return -1
    }
    return 0
  })

  const fallbackListingPage = listingPages[0]

  let listingPage = currentLanguageListingPage
  if (!currentLanguageListingPage) {
    listingPage = fallbackListingPage
  }
  if (!listingPage) {
    return
  }

  let listingPageContent = JSON.parse(listingPage?.content)
  let listingPath = listingPageContent.listingPath
  const teasers = allStories.filter((node) => {
    if (listingPath.includes(",")) {
      let returnValue = false
      let listingPathArray = listingPath.split(",")
      for (var i = 0; i < listingPathArray.length; i++) {
        returnValue =
          returnValue ||
          (node.content &&
            blok.bigBlogTeaserListing &&
            node.full_slug.startsWith(listingPathArray[i]) &&
            node.first_published_at <= today)
      }
      return returnValue
    } else {
      return (
        node.content &&
        blok.bigBlogTeaserListing &&
        node.full_slug.startsWith(listingPath) &&
        node.first_published_at <= today
      )
    }
  })
  const latestTeasers = teasers.slice(
    0,
    Math.min(blok.maxEntries, teasers.length)
  )

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <BigBlogTeasers
        heading={blok.headline}
        buttonLink={listingPage ? listingPage.uuid : ""}
        buttonText={blok.callToAction}
        linkTarget={blok.linkTarget}
        currentLanguage={blok.currentLanguage}
      >
        {latestTeasers.map((teaser, index) => {
          let content = JSON.parse(teaser.content)
          let teasersVisibility = []
          if (content.body) {
            teasersVisibility = content.body[1].componentVisibility || []
          }

          content.link = teaser.uuid
          content.date = teaser.sort_by_date
          content.tagList = teaser.tag_list
          content.currentLanguage = blok.currentLanguage

          let blogTeaser
          if (
            teasersVisibility.length === 0 ||
            teasersVisibility.includes(blok.currentLanguage)
          ) {
            blogTeaser = <BigBlogTeaser key={index} blok={content} />
          }

          return blogTeaser
        })}
      </BigBlogTeasers>
    </div>
  )
}

export default BigBlogTeasersEditable
